module.exports = __webpack_public_path__ + "src/assets/img/mini-img.f2a00eae.jpg";